module.exports = __webpack_public_path__ + "img/bgIcon_1.8ebe8abf.png";